/**
 * Plugin
 */
export default class {
  constructor (name) {
    this.name = name
    this.pipedPlugins = []
  }

  /**
   * adds a plugin, which will receive plugin value updates
   * @param plugin
   */
  addPipedPlugin (plugin) {
    this.pipedPlugins.push(plugin)
  }
}
